import React, {Fragment, useEffect, useState} from 'react';

const ProgressBar = ({star}) => {
  // console.log('star', star);
  return (
    <div className="row" key={star.label}>
                <div className="col-lg-2 review_progres_title"><small><strong>{star.label}</strong></small></div>
                <div className="col-lg-9">
                <div className="progress">
    <div className="progress-bar" role="progressbar" style={{width: `${star.percent || 0}%`}} aria-valuenow={`${star.percent}`} aria-valuemin="0"
      aria-valuemax="100"></div>
  </div>              
                </div>
                <div className="col-lg-1 review_progres_title"><small><strong>{star.value}</strong></small></div>
              </div>
    
  )
}
const ReviewSummary = (props) => {
  const { listing, reviewsMeta } = props;
  
  const stars = [5,4,3,2,1].map((star) => ({
    label: `${star} ${star < 2 ? 'star' : 'stars'}`,
    value: reviewsMeta[`star_${star}`],
    percent: Math.ceil(+reviewsMeta[`star_${star}`] * 100/Math.max(reviewsMeta.total,1))
  }));

  // const stars = [
  //   {label: 5, value: 77},
  //   {label: 4, value: 15},
  //   {label: 3, value: 18},
  //   {label: 2, value: 10},
  //   {label: 1, value: 5},
  // ]
  if(!reviewsMeta.total || reviewsMeta.total === 0) return (
    <div className="reviews-container">
      <h3 className="primary-text-color">THERE ARE NO COMMENTS YET.</h3>
     </div>      
  )
  const avg_rating = Math.round(reviewsMeta.avg_rating*10)/10;
  return (
    <Fragment>
      <div className="reviews-container">
       
        <div className="row">
          <div className="col-lg-3">
            <div id="review_summary">
              <strong>{avg_rating}</strong>
              <em>Overall rating</em>
              <small>Out of {Math.round(reviewsMeta.total*100)/100} Reviews</small>
            </div>
          </div>
          <div className="col-lg-9">
            {
              stars.map((star, idx) => (
               <ProgressBar key={`${star.value}-${idx}`} star={star}/>
              ))
            }            
          </div>
        </div>
      </div>
      </Fragment>
  )
}
export default ReviewSummary;